import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'mxAccountList',
})
export class MxAccountList implements PipeTransform {
  transform(value: any): any {
    try {
      return value.userAccounts?.filter((x) => x.vaultUserForm == null).length;
    } catch (error) {
      return 0;
    }
  }
}
